<template>
  <div>
    <svg width="100%" height="95">
      <rect x="0" y="0" width="100%" height="80" class="background-rect"></rect>
      <g class="truck">
        <rect
          x="0"
          y="0"
          width="507.067910798122"
          height="80"
          class="background-rect-complete"
        ></rect>
        <rect
          class="currentTimeLine"
          width="2"
          height="115"
          x="507.067910798122"
          y="-15"
        ></rect>
      </g>
      <g class="x axis" transform="translate(8,80)" v-if="actualHour < 14">
        <path class="domain" d="M 0 0 L 983.59 0"></path>

        <g class="tick" transform="translate(-5, 0)">
          <text dy=".32em" x="96.05251173708919" y="10">
            08:00
          </text>
        </g>
        <g class="tick" transform="translate(-5, 0)">
          <text dy=".32em" x="230.07927230046948" y="10">
            09:00
          </text>
        </g>
        <g class="tick" transform="translate(-5, 0)">
          <text dy=".32em" x="364.10603286384975" y="10">
            10:00
          </text>
        </g>
        <g class="tick" transform="translate(-5, 0)">
          <text dy=".32em" x="498.13279342723007" y="10">
            11:00
          </text>
        </g>
        <g class="tick" transform="translate(-5, 0)">
          <text dy=".32em" x="632.1595539906103" y="10">
            12:00
          </text>
        </g>
        <g class="tick" transform="translate(-5, 0)">
          <text dy=".32em" x="766.1863145539907" y="10">
            13:00
          </text>
        </g>
        <g class="tick" transform="translate(-5, 0)">
          <text dy=".32em" x="900.2130751173709" y="10">
            14:00
          </text>
        </g>
      </g>
      <g class="x axis" transform="translate(8,80)" v-else>
        <path class="domain" d="M 0 0 L 983.59 0"></path>

        <g class="tick" transform="translate(-5, 0)">
          <text dy=".32em" x="96.05251173708919" y="10">
            14:00
          </text>
        </g>
        <g class="tick" transform="translate(-5, 0)">
          <text dy=".32em" x="230.07927230046948" y="10">
            15:00
          </text>
        </g>
        <g class="tick" transform="translate(-5, 0)">
          <text dy=".32em" x="364.10603286384975" y="10">
            16:00
          </text>
        </g>
        <g class="tick" transform="translate(-5, 0)">
          <text dy=".32em" x="498.13279342723007" y="10">
            17:00
          </text>
        </g>
        <g class="tick" transform="translate(-5, 0)">
          <text dy=".32em" x="632.1595539906103" y="10">
            18:00
          </text>
        </g>
      </g>
      <g transform="translate(8,0)">
        <svg
          v-for="(route, index) in routes.services"
          :key="index"
          width="26"
          height="26"
          class="timeline-circle red"
          viewBox="0,0,19,21"
          fill="none"
          :x="positionX(index)"
          y="5.599999999999994"
        >
          <path
            d="M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z"
            :fill="colorPath(route)"
            stroke="white"
          ></path>
        </svg>
        <!-- <svg
          width="26"
          height="26"
          class="timeline-circle"
          viewBox="0,0,19,21"
          fill="none"
          x="100.48295774647886"
          y="5.599999999999994"
        >
          <path
            d="M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z"
            fill="#1ab394"
            stroke="#2b2b2b"
          ></path>
        </svg> -->
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Timeline",
  props: {
    routes: {
      type: Object,
    },
  },
  computed: {
    
    actualHour() {
      const d = new Date();
      let hour = d.getHours();
      return hour;
    },
  },
  methods: {
    colorPath(route){
      if(route.descState==="EN_RUTA"){
        return "#ffc107";
      }
      else if(route.descState==="NO_REALIZADA"){
        return "#fb465c";
      }
      else {
        return "#19be2b";
      }
    },
    positionX(index) {
      if (index == 0) return 1 * 10;
      else {
        let result = (index + 2) * 25;
        const numbersAsString = `${result}`;
        // Number((num / 100).toFixed(2));
        return numbersAsString;
      }
    },
  },
};
</script>

<style>
.red{
  color:blue !important
}
.background-rect-complete {
  fill: #fafafa;
}
.background-rect {
  fill: #fafafa;
}
.currentTimeLine {
  fill: #f4b424;
}
.axis .domain {
  stroke-width: 1;
  stroke-dasharray: 3px, 3px, 3px, 3px;
  stroke: #a1a1a1;
  fill: none;
  stroke-width: 1;
  shape-rendering: crispEdges;
}
.axis .tick text {
  fill: #a1a1a1;
  font-size: 9px;
  font-weight: normal;
}
</style>
